export default __webpack_public_path__ + "images/assets/40073c3242df4e89c47d099f13ad6283.svg";